import { FerramentaVideoService } from 'core/http/service/ferramentaVideo/FerramentaVideo.service';
import { IFVContents } from 'pages/ferramentaVideo/interfaces/FVContents.interface';
import { IFVPackageUnit } from 'pages/ferramentaVideo/interfaces/FVPackageUnit.interface';
import { useMutation, useQuery, useQueryClient } from 'react-query';

const service = new FerramentaVideoService();

const fetchPackageUnit = async (id: number): Promise<IFVPackageUnit> => {
    const { data } = await service.fetchPackageUnitByIdUnit(id);
    return data;
};

const createContent = async (idUnit: number, dataContent: IFVContents) => {
    const { data } = await service.createContent(idUnit, dataContent);
    return data;
};

const updateContent = async (idContent: number, dataContent: IFVContents) => {
    const { data } = await service.updateContent(idContent, dataContent);
    return data;
};

const deleteContent = async (idContent: number) => {
    await service.deleteContent(idContent);
};

const addContentVideo = async (idContent: number, file: File) => {
    const { data } = await service.addVideoContent(idContent, file);
    return data;
};

export function useFVContent(idUnit: number) {
    const queryClient = useQueryClient();

    const listQuery = useQuery(['packageUnit', idUnit], async ({ queryKey }) => {
        const [, id] = queryKey as [string, number];
        return fetchPackageUnit(id);
    });

    const createContentMutation = useMutation((data: IFVContents) => createContent(idUnit, data), {
        onSuccess: () => {
            queryClient.invalidateQueries(['packageUnit', idUnit]);
        },
    });

    const updateContentMutation = useMutation((data: IFVContents) => updateContent(data.codigo, data), {
        onSuccess: () => {
            queryClient.invalidateQueries(['packageUnit', idUnit]);
        },
    });

    const deleteContentMutation = useMutation((idContent: number) => deleteContent(idContent), {
        onSuccess: () => {
            queryClient.invalidateQueries(['packageUnit', idUnit]);
        },
    });

    const addVideoContentMutation = useMutation(({ idContent, file }: { idContent: number; file: File }) => addContentVideo(idContent, file), {
        onSuccess: () => {
            queryClient.invalidateQueries(['packageUnit', idUnit]);
        },
    });


    const handleRefresh = () => {
        queryClient.invalidateQueries(['packageUnit', idUnit]);
    }

    return { listQuery, createContentMutation, updateContentMutation, deleteContentMutation, addVideoContentMutation, handleRefresh };
}
